<template>
    <div>
        <div ref="load" class="loading">
            <div class="box flex">Loading<span></span></div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from "vue";

const load = ref(null);
const isActive = ref(false);
const process = ref(false);
const r = {};
let timeout = null;
const count = ref(0);

const run = () => {
    process.value = true;

    clearTimeout(timeout);
    timeout = setTimeout(() => {
        process.value = false;
    }, 300);
};

watch(() => process.value, async (nv, ov) => {
    if (!ov || !nv) {
        if (isActive.value) { load.value.classList.add('active'); }
        else {
            //if (count.value == 0) { load.value.classList.remove('active'); }
            load.value.classList.remove('active');
        }
    }
});
watch(() => isActive.value, async (nv, ov) => {
    run();
});

r.start = () => { isActive.value = true; count.value++; }
r.end = () => { isActive.value = false; count.value--; }

defineExpose(r);
</script>

<style scoped>
.loading {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    text-align: center;
    background-color: #05090c;
    z-index: 998;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    opacity: 0;
    pointer-events: none;
}

.loading.active {
    pointer-events: all;
    opacity: 0.5;
}

.loading .box {
    font-size: 1.5em;
    color: #ffffff;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-animation: opac 2s infinite linear;
    animation: opac 2s infinite linear;
}

.loading span {
    width: 8em;
    height: 8em;
    display: block;
    position: absolute;
    top: calc(50% - 4em);
    left: calc(50% - 4em);
    border: 2px solid;
    border-color: #ffffff transparent #ffffff transparent;
    border-radius: 50%;
    -webkit-animation: spin 2s infinite linear;
    animation: spin 2s infinite linear;
}

@-webkit-keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}

@keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}

@-webkit-keyframes opac {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0.4;
    }

    100% {
        opacity: 1;
    }
}

@keyframes opac {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0.4;
    }

    100% {
        opacity: 1;
    }
}
</style>
